import { Component, Input, OnInit } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { ModalService } from '../modal/modal.service';
import { PassDetailCardModalComponent } from '@finder/shared/components/pass-detail-card-modal/pass-detail-card-modal.component';
import { PassDetailCardInterface } from './pass-detail-card.interface';
import { HeaderData } from '@finder/shared/interfaces/shared.interface';
import { CommonModule } from '@angular/common';
import { PictureComponent } from '../picture/picture.component';
import { ButtonComponent } from '../button/button.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { KebabCasePipe } from '@finder/shared/utils/pipes/kebab-case/kebab-case.pipe';

@Component({
    selector: 'finder-pass-detail-card',
    templateUrl: './pass-detail-card.component.html',
    styleUrls: ['./pass-detail-card.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PictureComponent,
        ButtonComponent,
        FontIconComponent,
        ComponentHeaderComponent,
        SafeHtmlPipe,
        KebabCasePipe,
    ],
})
export class PassDetailCardComponent implements OnInit {

    @Input() data: PassDetailCardInterface;
    @Input() headerData: HeaderData;

    passDetailCardModal: ModalComponent[] = [];

    constructor(
        private modalService: ModalService,
    ) { }

    ngOnInit() {
        this.createPassDetailCardModal();
    }

    createPassDetailCardModal() {
        this.passDetailCardModal = this.data?.pass?.map((pass) => this.modalService.create(
            PassDetailCardModalComponent,
            {
                title: pass.passTitle,
                hideOnClose: true,
                data: pass?.modal,
                id: 'any'
            }
        ));
    }

    openPassDetailModal(passIndex: number) {
        this.passDetailCardModal[passIndex].open();
    }
}
